import GenericRepository from './GenericRepository';

const repositories = {
  campaign: new GenericRepository('surveys'),
  tricks: new GenericRepository('tricks'),
  brands: new GenericRepository('brands'),
  classes: new GenericRepository('classes'),
  users: new GenericRepository('users'),
  withdrawal: new GenericRepository('withdraws/payments'),
  branch: new GenericRepository('branches'),
  partners: new GenericRepository('partners'),
  question: new GenericRepository('questions'),
  profiles: new GenericRepository('profiles/questions'),
  items: new GenericRepository('items'),
  brandsType: new GenericRepository('brandsType'),
};

export class RepositoryFactory {
  constructor(name) {
    this.name = name;
  }

  create = payload => repositories[this.name].create(payload);
  get = page => repositories[this.name].get(page);
  getById = id => repositories[this.name].getById(id);
  getWithSearch = (search, customParams, page, limit) => repositories[this.name].getWithSearch(search, customParams, page, limit);
  patch = (id, payload) => repositories[this.name].patch(id, payload);
  update = (id, payload) => repositories[this.name].update(id, payload);
  delete = id => repositories[this.name].delete(id);
}
